import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import React from 'react';
import { ContentItem, RecyclingTemplate } from 'types/next';

type ContentDataProps = {
  contentData: RecyclingTemplate;
};

const Recycling = ({ contentData }: ContentDataProps) => {
  const desktopImage = contentData?.heroBanner?.desktopImage;
  const mobileImage = contentData?.heroBanner?.mobileImage;
  const sections: ContentItem[] = contentData?.contents || [];

  return (
    <div className="container mx-auto px-4">
      {/* Hero Section */}
      <div className="hero-section mb-20">
        <img
          src={`https://${desktopImage?.defaultHost}/i/${desktopImage?.endpoint}/${desktopImage?.name}`}
          className="hidden w-full md:block"
          alt="Desktop Banner"
        />
        <img
          src={`https://${mobileImage?.defaultHost}/i/${mobileImage?.endpoint}/${mobileImage?.name}`}
          className=" h-auto w-full  md:hidden"
          alt="Mobile Banner"
        />
      </div>

      {/* Content Sections */}
      <div className="space-y-12">
        {sections &&
          sections?.length > 0 &&
          sections?.map((section: ContentItem, index: number) => (
            <div key={index} className="flex flex-col gap-6">
              <div className="">
                <h2 className={`mb-30 text-29 font-bold text-gray-800`}>{section?.title}</h2>
                <MarkDownDescription markdownText={section?.description} classname="WEEE" />
              </div>

              {/* Right Side - Image (If available) */}
              {section.image && (
                <div className={`${index === 7 ? 'w-[94px]' : index === 3 ? 'w-[44px]' : 'w-[60px]'}`}>
                  <img
                    src={`https://${section.image.defaultHost}/i/${section.image.endpoint}/${section.image.name}`}
                    alt={section.title}
                    className="w-full rounded-lg shadow-md"
                  />
                </div>
              )}
            </div>
          ))}
      </div>
    </div>
  );
};

export default Recycling;
